import React from 'react';
import Suspense from '../../services/lazyLoad/Suspense';
import { useMediaQuery } from '@material-ui/core';
import LargeBanner from '../../components/common/Subscription/BecomePremiumTopBar/BigBanner';
import { useSubscriptionPermission } from '../../hooks/useSubscriptionPermission';

const PlaceholderDesktop = React.lazy(() => import('./Placeholder/PlaceholderDesktop'));
const PlaceholderMobile = React.lazy(() => import('./Placeholder/PlaceholderMobile'));

export default function TeamingOpportunitiesWrapper() {
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const { hasPermission } = useSubscriptionPermission('teaming-opportunities');

  return (
    <>
      <LargeBanner permissionKey="teaming-opportunities" />

      <div className={!hasPermission ? 'blurNotSubscribed' : ''}>
        <Suspense>{isMobile ? <PlaceholderMobile /> : <PlaceholderDesktop />}</Suspense>
      </div>
    </>
  );
}
